<template>
  <div>
    <v-dialog
      ref="dialog"
      :value="dialog.state"
      width="875px"
      max-width="875px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      persistent
      scrollable
    >
      <v-card tile flat>
        <v-card-title class="pa-0">
          <v-toolbar color="primary" dark flat tile dense height="45">
            <v-btn
              id="cerrarBtnSol"
              icon
              dark
              @click="cerrar(false)"
              right
              absolute
            >
              <v-icon>mdi-close-circle</v-icon>
              <v-tooltip bottom activator="#cerrarBtnSol">Cerrar</v-tooltip>
            </v-btn>
            <v-toolbar-title class="flex text-center titulo titulo-local">
              {{ titulo }}
            </v-toolbar-title>
          </v-toolbar>
        </v-card-title>

        <v-card-text v-if="step === 1">
          <elegir-tipo
            :desarrollo="bitsCliente?.b_desarrollo_cliente"
            :soporte="bitsCliente?.b_soporte"
            :cotizacion="bitsCliente?.b_cotizacion"
            @select-tipo="seleccionarTipo"
          />
        </v-card-text>
        <v-card-text v-else class="pa-0">
          <v-alert
            outlined
            color="orange"
            border="left"
            icon="mdi-alert"
            class="ma-6"
            dense
          >
            Los requerimientos que no sean claramente especificados, podrían ser
            cancelados y se deberá crear nuevamente la solicitud.
            <template v-slot:prepend>
              <div class="align-center ml-1 mr-4">
                <v-icon color="orange">mdi-alert-circle</v-icon>
              </div>
            </template>
          </v-alert>
          <v-form ref="form" v-model="valid" class="mt-5" :disabled="loading">
            <v-row dense class="px-4 ma-0">
              <v-col cols="12">
                <v-text-field
                  v-model="nombre"
                  readonly
                  label="Solicitante"
                  :rules="[reglas.required]"
                  v-bind="fieldProps"
                  style="pointer-events: none"
                >
                  <template #prepend>
                    <v-icon color="primary"> mdi-account-box</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-select
                  v-model="form.id_area"
                  v-bind="fieldProps"
                  :items="areas"
                  :rules="[reglas.required2]"
                  :loading="loadingAreas"
                  item-text="clice_c_nombre"
                  item-value="clice_s_id"
                  label="Area"
                  placeholder="Seleccione el área"
                  readonly
                  style="pointer-events: none"
                >
                  <template #prepend>
                    <v-icon color="primary"> mdi-shape-plus-outline</v-icon>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  v-model="form.id_modulo"
                  v-bind="fieldProps"
                  :items="modulos"
                  :rules="[reglas.required2]"
                  :loading="loadingModulos"
                  item-text="modce_c_nombre"
                  item-value="modce_s_id"
                  label="Modulo"
                  placeholder="Seleccione el módulo"
                >
                  <template #prepend>
                    <v-icon color="primary"> mdi-transit-connection</v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="6">
                <v-select
                  v-model="form.id_prioridad"
                  :items="prioridades"
                  item-text="prior_c_nombre"
                  item-value="prior_s_id"
                  label="Prioridad"
                  placeholder="Seleccione la prioridad"
                  :rules="[reglas.required2]"
                  v-bind="fieldProps"
                  :loading="loadingPrioridades"
                >
                  <template #prepend>
                    <v-icon color="primary"> mdi-priority-high </v-icon>
                  </template>
                </v-select>
              </v-col> -->
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.solicitante"
                  v-bind="fieldProps"
                  :rules="[reglas.required, reglas.maxChar(50)]"
                  label="Nombre Solicitante"
                  placeholder="Nombre Solicitante"
                  counter="50"
                  maxlength="50"
                >
                  <template #prepend>
                    <v-icon color="primary"> mdi-account-arrow-right </v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.resumen"
                  v-bind="fieldProps"
                  :rules="[reglas.required, reglas.maxChar(50)]"
                  label="Resumen"
                  placeholder="Resumen de su solicitud"
                  counter="50"
                  maxlength="50"
                >
                  <template #prepend>
                    <v-icon color="primary"> mdi-text-short </v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="form.descripcion"
                  v-bind="fieldProps"
                  :rules="[
                    reglas.required,
                    reglas.maxChar(paramGenerales.ticket_comment_size),
                  ]"
                  placeholder="Descripción de su solicitud"
                  label="Descripción"
                  :counter="paramGenerales.ticket_comment_size"
                  :maxlength="paramGenerales.ticket_comment_size"
                  rows="2"
                  auto-grow
                >
                  <template #prepend>
                    <v-icon color="primary"> mdi-text </v-icon>
                  </template>
                </v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-file-input
                  v-model="archivos"
                  :rules="[
                    reglas.maxSize(paramGenerales.ticket_size_files),
                    reglas.allowedFiles(permitidos),
                    reglas.ticketCantMaxFiles(paramGenerales.ticket_cant_files),
                  ]"
                  :accept="permitidos"
                  :hint="`Puede adjuntar hasta ${
                    paramGenerales.ticket_cant_files
                  } archivos a la vez, cada uno con un tamaño inferior a ${
                    paramGenerales.ticket_size_files
                  } MB.\n\nFormatos permitidos: ${permitidos.join(', ')}`"
                  dense
                  show-size
                  :clearable="false"
                  placeholder="Subir archivos (Opcional)"
                  class="mx-4 file-hint"
                  small-chips
                  filled
                  rounded
                  multiple
                  :counter="paramGenerales.ticket_cant_files"
                  :counter-string="
                    paramGenerales.ticket_cant_files + 'archivos máximo'
                  "
                  persistent-hint
                  background-color="rgba(200, 200, 200, .15)"
                  @change="convertirArchivo"
                >
                  <template #prepend>
                    <v-icon color="primary"> mdi-paperclip-plus </v-icon>
                  </template>
                  <template #append>
                    <ayuda-hover
                      height="auto"
                      width="225px"
                      texto="Si desea adjuntar archivos que no se encuentran en los formatos permitidos, se recomienda comprimirlos en archivos .zip o .rar"
                    />
                  </template>
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      color="primary accent-4"
                      dark
                      label
                      small
                      close
                      @click:close="eliminarArchivo(index)"
                    >
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
                <v-divider class="hidden-md-and-up" />
              </v-col>
              <v-col cols="12" class="d-flex mt-3">
                <v-btn color="error" class="mr-2" @click="cerrar(false)">
                  <v-icon left>mdi-window-close</v-icon>
                  Cerrar
                </v-btn>
                <v-btn v-if="step == 2" color="warning" @click="step = 1">
                  <v-icon left>mdi-arrow-left</v-icon>
                  Volver
                </v-btn>
                <v-spacer></v-spacer>
                <div class="d-flex flex-column">
                  <v-btn
                    :loading="loading"
                    :disabled="loading || blockAccess"
                    class="mx-2 my-2"
                    color="primary"
                    @click="!blockAccess && validate()"
                  >
                    <v-icon left>mdi-file-plus</v-icon>
                    Ingresar Solicitud
                  </v-btn>
                  <span v-if="blockAccess" class="error--text">
                    Deshabilitado por clave maestra
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AyudaHover from "./AyudaHover.vue";
import tickets from "@/services/tickets";
import reglas from "@/utils/reglas";
import symbols from "../tickets/dialogos/symbols";
import { mapActions, mapState } from "vuex";
import ElegirTipo from "./ElegirTipo.vue";
import auth from "@/services/auth";

export default {
  components: {
    AyudaHover,
    ElegirTipo,
  },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
    titulo: {
      type: String,
      default: "Solicitud de Ticket",
    },
  },
  data() {
    return {
      reglas,
      step: 1,
      valid: true,
      nombre: "",
      form: {
        id_usuario: "",
        id_prioridad: "",
        id_modulo: "",
        id_area: "",
        descripcion: "",
        resumen: "",
        solicitante: "",
      },
      fieldProps: {
        filled: true,
        rounded: true,
        required: true,
        dense: true,
        class: "mx-2",
        hideDetails: "auto",
        backgroundColor: "rgba(200, 200, 200, .15)",
      },
      permitidos: [
        ".jpg",
        ".png",
        ".jpeg",
        ".pdf",
        ".xls",
        ".xlsx",
        ".doc",
        ".docx",
        ".txt",
        ".msg",
        ".oft",
        ".rar",
        ".zip",
      ],
      archivosTotal: [],
      archivos: [],
      archivos_convertidos: null,
      loading: false,
      areas: [],
      modulos: [],
      prioridades: [],
      loadingAreas: true,
      loadingModulos: true,
      loadingPrioridades: true,
      selects: {
        areas: 13,
        modulos: 2,
        prioridades: 3,
      },
    };
  },
  computed: {
    ...mapState(["bitsCliente", "blockAccess", "paramGenerales"]),
    userLogged() {
      return auth.getUserLogged();
    },
  },
  methods: {
    ...mapActions(["mostrarAlerta", "cerrarAlerta", "actualizarContador"]),
    cerrar(solicita) {
      this.$emit("cerrar", solicita);
    },
    async validate() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        await this.solicitarTicket();
        this.loading = false;
      }
    },
    async cargarAreas() {
      this.loadingAreas = true;
      await tickets
        .getSeleccionables(this.selects.areas)
        .then((response) => {
          this.areas = response.data;
        })
        .catch((error) => console.error(error));
      this.loadingAreas = false;
    },
    async cargarModulos() {
      this.loadingModulos = true;
      await tickets
        .getSeleccionables(this.selects.modulos, {
          sucursal: this.userLogged.id_sucursal,
          area: this.form.id_area,
        })
        .then((response) => {
          response.data.forEach((mod) => {
            let split = mod.modce_c_nombre.split("_");
            if (split.length > 1) mod.modce_c_nombre = split[1];
            else mod.modce_c_nombre = split[0];

            this.modulos.push(mod);
            this.modulos.sort(function (a, b) {
              return a.modce_c_nombre.localeCompare(b.modce_c_nombre);
            });
          });
        })
        .catch((error) => console.error(error));
      this.loadingModulos = false;
    },

    async solicitarTicket() {
      let payload = {};
      let form = JSON.parse(JSON.stringify(this.form));
      form.solicitante = "Nombre Solicitante: " + form.solicitante;
      await tickets
        .solicitarTicket(form)
        .then(async (response) => {
          if (response.data) {
            if (this.archivos_convertidos != null)
              await this.archivos_convertidos.forEach(async (doc) => {
                doc.crevi_s_id = response.data[0].return_value;
                await this.subirArchivo(doc);
              });

            payload = {
              mensaje:
                "Se ha generado su ticket con ID: " +
                response.data[0].return_value,
              color: "success",
              mostrar: true,
            };
            this.actualizarContador(this.dialog.user.id_usuario);
            this.cerrar(true);
          } else {
            this.cerrar(true);
          }
        })
        .catch((error) => {
          console.error(error);
          payload = {
            mensaje: data.msg,
            color: "error",
            mostrar: true,
          };
          this.cerrar(false);
        });
      this.mostrarAlerta(payload);
      this.loading = false;
    },
    async convertirArchivo(archivos) {
      if (archivos.length > 0) {
        let noRepetidos = archivos.filter(
          (e) => !this.archivosTotal.some((a) => a.name === e.name)
        );

        this.archivosTotal.push(...noRepetidos);
        this.archivos = [...this.archivosTotal];

        this.archivos_convertidos = [];
        archivos.forEach(async (doc) => {
          let convert = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(doc);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
          });
          let archivo_convertido = {
            id_usuario: this.dialog.user.id_usuario,
            nombre_doc: this.sanitizeName(doc.name),
            largo_doc: doc.size,
            documento_b64: convert.split(",")[1],
          };
          this.archivos_convertidos.push(archivo_convertido);
        });
      } else this.archivos_convertidos = null;
    },
    async subirArchivo(archivo) {
      await tickets
        .subirArchivo(archivo)
        .then((response) => {
          //
        })
        .catch((error) => {
          console.error(error);
          this.mostrarAlerta({
            mensaje: "Ocurrió un error al procesar los archivos",
            color: "error",
            mostrar: true,
          });
        });
    },
    eliminarArchivo(index) {
      this.archivos_convertidos = this.archivos_convertidos.filter(
        (e) => e.nombre_doc !== this.archivos[index].name
      );
      // this.archivos_convertidos.splice(index, 1);

      this.archivos.splice(index, 1);
      this.archivosTotal.splice(index, 1);
    },
    sanitizeName(name) {
      return name.replace(symbols, "_");
    },
    seleccionarTipo(tipo) {
      this.form.id_area = tipo;
      this.cargarModulos();
      this.step = 2;
    },
  },
  async mounted() {
    this.cargarAreas();

    // this.cargarPrioridades();
    this.nombre = this.dialog.user.nombre.split("(")[0];
    this.form.id_usuario = this.dialog.user.id_usuario;
  },
};
</script>
<style scoped lang="css">
.titulo-local {
  font-size: 22px;
  line-height: 25px;
}
</style>
